import React from 'react'

const TestimonialCard = (quoteItem) => {
    return (
<div className={"block duration-700 ease-in-out h-full"} data-carousel-item>
<div className="relative rounded-2xl shadow-xl overflow-hidden h-full">
<img
className="absolute inset-0 h-full w-full object-cover"
src={require('../images/umbrellaInRain.jpg')}
alt="Rain"
/>
<div className="absolute inset-0 bg-mainTheme mix-blend-multiply" />
<div className="absolute inset-0 bg-gradient-to-t from-mainThemeTinted via-mainThemeTinted opacity-50" />
<div className="relative px-8">
<blockquote className="mt-12 sm:mt-32 w-5/6 ml-2 sm:ml-11">
   <div className="relative text-lg font-medium text-white md:flex-grow">
       <svg
           className="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-mainTheme"
           fill="currentColor"
           viewBox="0 0 32 32"
           aria-hidden="true"
       >
           <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
       </svg>
       <p className="relative ml-8 text-sm sm:text-base">
       {quoteItem.quoteItem.quote}
       </p>
   </div>

   <footer className="mt-4 flex items-start">
   <div className="flex-shrink-0 inline-flex rounded-full border-2 border-white">
                  <img
                    className="h-12 w-12 rounded-full"
                    src={quoteItem.quoteItem.image}
                    alt=""
                  />
                </div>
                <div>
   <p className="text-sm sm:text-base font-semibold text-white ml-4 mt-3 pb-12">
           {quoteItem.quoteItem.name}
       </p>
       </div>
   </footer>
</blockquote>
</div>
</div>
</div>
    )
}
export default TestimonialCard